import { useNavigate } from "react-router-dom";
import { Row, Col } from 'react-bootstrap';
import BackIcon from '../../../../styles/images/back-without-bg.png';
import TutorialImg from '../../../../styles/images/tutorial.jpg';


const Tutorial = () => {

    const navigate = useNavigate();

    const handleBackBtn = () => {
        navigate(-1);
    };


    return (

        <div id="rules-page">
            <Row className="py-3 white-bg sticky top-0 z-index-2">
                <Col xs={1} className="d-flex align-items-center"><img src={BackIcon} alt="back" onClick={handleBackBtn} role="button" /></Col>
                <Col xs={10} className="text-center">
                    <div className="header_h3">
                        روش های پرداخت
                    </div>
                </Col>
                <Col xs={1}></Col>
            </Row>

            <Row className="mt-5">
                <img src={TutorialImg} className="w-100" alt="tutorial" />
            </Row>

        </div>

    );
}

export default Tutorial;